const get = require('lodash/get')

module.exports.isLocationAtLeastLevel = (location, level) => get(location, 'additionalData.level', '0') >= level
